const VerticalLayout = () => import('@/layouts/VerticalLayout')

const AdminsList = () => import('./views/list.vue')

export default [
  {
    path: '/admins',
    name: 'admins',
    component: VerticalLayout,
    children: [{
      path: '',
      name: 'admins',
      component: AdminsList,
      meta: { name: 'admins', userType: 'provider', serviceTypes: 'all' }
    }]
  }
]
